<template>
  <div class="Index">
    <closeZone></closeZone>
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">微信基础功能</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goInput">
        <div class="module_left">切换输入法</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Input1">
          <div class="module_right_icon2 Input2">
            <div class="module_right_icon3 Input3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goFriend">
        <div class="module_left">添加和删除好友</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Friend1">
          <div class="module_right_icon2 Friend2">
            <div class="module_right_icon3 Friend3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goChat">
        <div class="module_left">语音和视频聊天</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Chat1">
          <div class="module_right_icon2 Chat2">
            <div class="module_right_icon3 Chat3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goExpression">
        <div class="module_left">发语音和表情包</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Expression1">
          <div class="module_right_icon2 Expression2">
            <div class="module_right_icon3 Expression3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goCare">
        <div class="module_left">设置关怀模式</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Care1">
          <div class="module_right_icon2 Care2">
            <div class="module_right_icon3 Care3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goGroupChat">
        <div class="module_left">发起和退出群聊</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 GroupChat1">
          <div class="module_right_icon2 GroupChat2">
            <div class="module_right_icon3 GroupChat3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSpace">
        <div class="module_left">清理微信存储空间</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Space1">
          <div class="module_right_icon2 Space2">
            <div class="module_right_icon3 Space3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goWechat">
        <div class="module_left">发朋友圈</div>
        <div v-if="!isVipUser" class="left_lock"></div>
        <div class="module_right_icon1 Friend1">
          <div class="module_right_icon2 Friend2">
            <div class="module_right_icon3 pengyouquan"></div>
          </div>
        </div>
      </div>
    </div>

    <!--解锁畅享权益-->
    <van-popup v-model="showPopup" position="bottom" :overlay="true">
      <div class="popup-info">
        <div class="popup-info-bk">
          <div class="popup-info-close" @click="handleCloseVip"></div>
          <div class="popup-info-quanyi"></div>
          <div class="popup-info-vip" @click="handleToggleVip"></div>
        </div>
      </div>
    </van-popup>

    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import VanPopup from 'vant/lib/popup'
import 'vant/lib/popup/style'

export default {
  name: 'index',
  components: {
    VanPopup
  },
  data () {
    return {
      isVip: false,
      // 畅享权益
      direction: 'btt',
      drawer: false,
      showPopup: false
    }
  },
  created () {},

  mounted () {
    this.isVip = this.$store.getters.isVip
    // const urlParams = new URLSearchParams(window.location.search)
    // this.isVip = urlParams.get('isVip') === '1'
    // console.log(this.isVip)
  },
  beforeDestroy () {},
  computed: {
    isVipUser () {
      return this.isVip
    }
  },

  methods: {
    // 关闭畅享权益
    handleCloseVip () {
      this.showPopup = false
    },

    handleToggleVip () {
      wx.miniProgram.redirectTo({
        url: '/pagesPay/pay/index?orderType=vip'
      })
    },

    checkVip () {
      if (!this.isVip) {
        this.showPopup = true
        return false
      }
      return true
    },

    async goBack () {
      this.$router.replace({
        path: '/classification'
      })
    },
    async goFriend () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/friend/index1'
      })
    },
    async goChat () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/chat/index1'
      })
    },
    async goCare () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/care/index1'
      })
    },
    async goExpression () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/expression/index3'
      })
    },
    async goGroupChat () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/groupChat/index1'
      })
    },
    async goSpace () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/space/index1'
      })
    },
    async goInput () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/input/index1'
      })
    },
    async goWechat () {
      if (!this.checkVip()) {
        return
      }
      this.$router.push({
        path: '/wxSettings/weChat/index1'
      })
    }
  }
}
</script>
<style>
.popup-info {
  width: 100%;
  height: 85vh;
  position: relative;
}
.popup-info-close {
  position: absolute;
  top: 11%;
  right: 1.5%;
  width: 15%;
  height: 9%;
  background: url(@/assets/zone/closeQuanyi.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-bk {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(@/assets/zone/order.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-quanyi {
  position: absolute;
  top: 30%;
  left: 13%;
  width: 75%;
  height: 45%;
  background: url(@/assets/zone/quanyi.png) no-repeat center;
  background-size: 100% 100%;
}
.popup-info-vip {
  position: absolute;
  top: 80%;
  left: 20%;
  width: 70%;
  height: 19%;
  background: url(@/assets/zone/vip.png) no-repeat center;
  background-size: 100% 100%;
}

.van-popup {
  border-radius: 20px 20px 0 0;
  background: none !important;
}
</style>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(17, 195, 91),
    rgb(49, 210, 121) 26.718%,
    rgb(241, 255, 227) 100%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 20px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 44vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 30px;
    top: 70px;
    z-index: 0;
    width: 386px;
    height: 290px;
    background: url(@/assets/wxSettings/wxSettingsIndex/wxSettingsIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  width: 100%;
  //margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  //padding-right: 10px;
  //display: flex;
  //flex-wrap: wrap;
  //gap: 18px;
  //margin: 0 30px;
  //width: 90%;
  //margin: 0 auto;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: space-between;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 48%;
    padding: 27px 0;
    height: 95px;
    background: #ffffff;
    border-radius: 15px;
    //margin-bottom: 30px;
    //margin-right: 30px;
    .left_lock {
      position: absolute;
      top: 0;
      left: 0;
      width: 26%;
      height: 30%;
      background: url("@/assets/zone/lock.png") no-repeat;
      background-size: 100% 100%;
    }
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }

    .Input1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Input2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Input3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/input.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .pengyouquan {
      background: url("@/assets/colorBg/pengyouquan.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Friend1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Friend2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Friend3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/friend.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Chat1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Chat2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Chat3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/chat.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .Expression1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Expression2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Expression3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/expression.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Care1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Care2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Care3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/care.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .GroupChat1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .GroupChat2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .GroupChat3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/groupChat.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Space1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Space2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Space3 {
      background: url("@/assets/wxSettings/wxSettingsIndex/space.png") no-repeat
        center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
